import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import ScrollAnimation from 'react-animate-on-scroll';

class Counter extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="counter-area mg-top--50">
			  <div className="container">
			    <div className="row">
				  <div className="col-lg-3">
			        <div className="single-list-inner style-box-bg">
			          <div className="media">
			            <div className="media-left">
							<ScrollAnimation animateIn="fadeInUp">
			              		<img src={publicUrl+"assets/img/website/Experience.png"} alt="img" />
							</ScrollAnimation>
			            </div>
			            <div className="media-body align-self-center">
							<ScrollAnimation animateIn="fadeInUp">
								<h5><span className="counter">31 </span> Years</h5>
								<p>Experience</p>
				  			</ScrollAnimation>
			            </div>
			          </div>
			        </div>
			      </div>	
				  <div className="col-lg-3">
			        <div className="single-list-inner style-box-bg">
			          <div className="media">
			            <div className="media-left">
							<ScrollAnimation animateIn="fadeInUp">
			              		<img src={publicUrl+"assets/img/website/Happy-Students.png"} alt="img" />
							</ScrollAnimation>
			            </div>
			            <div className="media-body align-self-center">
							<ScrollAnimation animateIn="fadeInUp">
								<h5><span className="counter">25000 </span> +</h5>
								<p>Happy Students</p>
							</ScrollAnimation>
			            </div>
			          </div>
			        </div>
			      </div>
			      <div className="col-lg-3">
			        <div className="single-list-inner style-box-bg">
			          <div className="media">
			            <div className="media-left">
							<ScrollAnimation animateIn="fadeInUp">
			              		<img src={publicUrl+"assets/img/website/Placement-Record.png"} alt="img" />
							</ScrollAnimation>
			            </div>
			            <div className="media-body align-self-center">
							<ScrollAnimation animateIn="fadeInUp">
								<h5><span className="counter">90 </span> %</h5>
								<p>Placement Records</p>
							</ScrollAnimation>
			            </div>
			          </div>
			        </div>
			      </div>
			      <div className="col-lg-3">
			        <div className="single-list-inner style-box-bg">
			          <div className="media">
			            <div className="media-left">
							<ScrollAnimation animateIn="fadeInUp">
			              		<img src={publicUrl+"assets/img/website/Courses.png"} alt="img" />
							</ScrollAnimation>
			            </div>
			            <div className="media-body align-self-center">
							<ScrollAnimation animateIn="fadeInUp">
								<h5><span className="counter">50 </span> +</h5>
								<p>Courses</p>
							</ScrollAnimation>
			            </div>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>

        }
}

export default Counter